import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../../store/app.hooks';
import React from 'react';
import GlobalSearch from '../../../common/components/globalSearch/GlobalSearch';
import { IBackgroundProcessesProps } from './backgroundProcesses.model';
import MainTable from './MainTable';
import { Page } from '../../../common/constants/pageAction';
import BreadCrumbs from '../../../common/components/Breadcrumbs';
import { clearBackgroundProcesses } from '../../../store/backgroundProcesses/backgroundProcesses.reducer';

const BackgroundProcessess: React.FC<IBackgroundProcessesProps> = () => {
  const dispatch = useAppDispatch();
  const dataTableRef = useRef(null);

  const [showSelectedListModal, setShowSelectedListModal] = React.useState(false);

  useEffect(() => {
    setShowSelectedListModal(false);
    return () => {
      dispatch(clearBackgroundProcesses());
    };
  }, []);

  const tableButtons = () => <></>;

  return (
    <div className="ad">
      <div className="title-block">
        <h4 className="p-0">
          <BreadCrumbs pageName={Page.BackgroundProcesses} />
        </h4>
        <div className="right-title">
          <GlobalSearch />
        </div>
      </div>
      <div className="main-card">
        {/* <div className="input-btns-title">
          <Row gutter={[10, 4]}>
            <Can I={Action.ImportToExcel} a={Page.ADExclusions}>
              <Col>
                <Button
                  className="btn-icon"
                  onClick={() =>
                    history.push(
                      `/data-input/bulk-import/${encodeURIComponent(
                        backgroundProcessess.search.tableName
                      )}`
                    )
                  }
                  icon={
                    <em className="anticon">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/ic-file-excel-outlined.svg`}
                        alt=""
                      />
                    </em>
                  }
                >
                  Import
                </Button>
              </Col>
            </Can>
            <Can I={Action.DeleteData} a={Page.ADExclusions}>
              <Col>
                <Button
                  className="btn-icon"
                  onClick={() => setDeleteModalVisible(true)}
                  icon={
                    <em className="anticon">
                      <img src={`${process.env.PUBLIC_URL}/assets/images/ic-delete.svg`} alt="" />
                    </em>
                  }
                >
                  Delete Dataset
                </Button>
              </Col>
            </Can>
          </Row>
        </div> */}
        <MainTable
          ref={dataTableRef}
          isMultiple={showSelectedListModal}
          setShowSelectedListModal={(state) => {
            setShowSelectedListModal(state);
          }}
          tableButtons={tableButtons}
        />
      </div>
    </div>
  );
};

export default BackgroundProcessess;
